import Common from "../../../Common";

export interface PbxDid {
	id: id
	number: string
	e164: string
	type: "fixed" | "cell"
	pbx_destination_id: id
	ast_language_id: string
	description: string
	label: string
	removeable: 0 | 1 | "0" | "1"
	src_pbx_user_id: {[ key: string ]: {
		id: id
		extension: string
		user_name: string
	}}
}

const Did = class extends Common {
	async browse(companyId: id) {
		return this.get(`/company/${companyId}/pbx/did`);
	}

	async read(companyId: id, id: id) {
		return this.get(`/company/${companyId}/pbx/did/${id}`);
	}

	async create(companyId: id, data: any) {
		return this.post(`/company/${companyId}/pbx/did`, data);
	}

	async update(companyId: id, id: id, data: any) {
		return this.patch(`/company/${companyId}/pbx/did/${id}`, data);
	}

	async delete(companyId: id, id: id) {
		return this.doDelete(`/company/${companyId}/pbx/did/${id}`);
	}

	getFlow = (companyId: id, id: id) =>
		this.get(`/company/${companyId}/pbx/did/${id}/flow`)

	// TODO
	/*
	async delete(companyId: id, id: id) {
		return this.doDelete(`/company/${companyId}/pbx/did/${id}`);
	}

	async remove(companyId: id, id: id) {
		return this.doDelete(`/company/${companyId}/pbx/did/${id}`);
	}
	*/
}

export default Did
